import React from 'react';

const MisComunidades = () => {
  return (
    <div>
      <h1>Mis Comunidades</h1>
     
    </div>
  );
};

export default MisComunidades;
